import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { media } from 'lib';

const Footer = styled.div`
  position: relative;
  background: #fff no-repeat;
  padding: 10px 0 10px 0;
  box-shadow: 0 5px #fff, 0 0 4px rgba(9, 4, 6, 0.2);
  //margin-right: -70px;
  p {
    line-height: 26px;
    color: #ccc;
  }
  p .icon-base {
    margin-right: 5px;
  }
  a {
    color: #ccc;
  }
  .footer-link {
    padding-bottom: 8px;
  }
  .footer-link a {
    margin-right: 20px;
    color: #999;
    font-size: 14px;
  }
  .footer-link a:hover {
    color: ${(props) => props.theme.color.primary};
  }
  .footer-icon {
    display: flex;
    flex-flow: row nowrap;
  }
  .footer-icon a {
    text-align: left;
  }
`;

const PageFooter = () => {
  return (
    <Footer>
      <div className="container">
        <p className="footer-link">
          <a href="/help/7" target="_blank" data-sawebclick="id=001t09b001">
            帮助中心
          </a>
          <a href="/notice/10097" target="_blank" data-sawebclick="id=001t09b002">
            服务条款
          </a>
          <a href="/about.html" target="_blank" data-sawebclick="id=001t09b004">
            关于我们
          </a>
          {/*<a
            href="/partner.html"
            target="_blank"
            data-sawebclick="id=001t09b006">
            合作网站
          </a>*/}
          <a
            href="https://www.2339.com/notice/10499"
            target="_blank"
            data-sawebclick="id=001t09b007"
          >
            家长监护
          </a>
          <a href="/notice/10035" target="_blank" data-sawebclick="id=001t09b008">
            举报受理办法
          </a>
        </p>

        <p className="footer-copyright">© 2014-2025 么么直播 2339.com 版权所有</p>

        <p>
          <a rel="nofollow" href="http://beian.miit.gov.cn/" target="_blank">
            苏ICP备2024095074号-6
          </a>{' '}
          |
          <a rel="nofollow" href="https://jbts.mct.gov.cn/" target="_blank">
            12318全国文化市场举报网站
          </a>
        </p>

        <p>
          增值电信业务经营许可证：
          <a
            rel="nofollow"
            href="https://tsm.miit.gov.cn/dxxzsp/xkz/xkzgl/resource/qiyesearch.jsp?num=苏B2-20240885&type=xuke"
            target="_blank"
          >
            苏B2-20240885
          </a>{' '}
          | 违法不良信息举报邮箱：help@2339.com | 违法不良信息举报电话：021-60716982
        </p>

        <p>
          本公司游戏产品适合18岁以上成年人使用 | 抵制不良游戏，拒绝盗版游戏。
          注意自我保护，谨防受骗上当。 适度游戏益脑，沉迷游戏伤身。 合理安排时间，享受健康生活。
        </p>
        <p className="footer-icon">
          <a
            href="https://whsc.mr.mct.gov.cn/qrcode/networkInfo?id=ZTJkNDVkNThlZDMyNGFlZGFhODE4NjIyZDI4NTk0ZGI="
            target="_blank"
            rel="nofollow"
          >
            <i className="icon-base icon-base-wenhuajingying"></i> 苏网文(2024)2108-102号
          </a>
          <a href="https://www.12377.cn" target="_blank" rel="nofollow">
            <i className="icon-base icon-base-slefjubao"></i>
            网上有害信息举报专区
          </a>
        </p>
      </div>
    </Footer>
  );
};

export default PageFooter;
